import ViewTrainerAttendance from '../commonfile/ViewTrainerAttendance'

const ZoneHeadViewTrainerAtd = () => {

    return (
        <ViewTrainerAttendance />
    )
}

export default ZoneHeadViewTrainerAtd